import { createContext } from 'react'

export const DetalhesCasoContext = createContext(null)
